import APIinstance from '../config';

import { DebtScheduleDto } from '@/generated-types';

export const postDebtSchedules = async (
	payload: DebtScheduleDto,
	params: { hash: string },
): Promise<void> => {
	await APIinstance.post<void>(`debt-schedules`, payload, { params });
};
